import React from 'react';
import { Shield, Lock, CreditCard, CheckCircle } from 'lucide-react';

export const Trust = () => {
  const trustPoints = [
    {
      icon: Shield,
      title: "Secure Payments",
      description: "All payments processed through Stripe - industry-leading security standards"
    },
    {
      icon: Lock,
      title: "Your Data Protected",
      description: "Your personal and payment information is encrypted and never shared"
    },
    {
      icon: CreditCard,
      title: "No Card Details Stored",
      description: "Card information is handled entirely by our payment partners, not stored on our site"
    },
    {
      icon: CheckCircle,
      title: "Direct with Hosts",
      description: "Book directly with Caroline and Joe - no hidden fees or third-party markups"
    }
  ];

  return (
    <section className="py-12 sm:py-16 md:py-20 bg-[#FBFAF7]">
      <div className="container mx-auto px-4 sm:px-6">
        <div className="max-w-5xl mx-auto">
          {/* Header */}
          <div className="text-center mb-10 sm:mb-12">
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-light text-[#071936] mb-3">
              Safe, Simple, Secure
            </h2>
            <p className="text-base sm:text-lg text-[#6B7280]">
              Your booking and payment security is our priority
            </p>
          </div>

          {/* Trust Grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 sm:gap-8">
            {trustPoints.map((point) => {
              const IconComponent = point.icon;
              return (
                <div
                  key={point.title}
                  className="flex items-start gap-4 p-6 bg-white rounded-lg border border-[rgba(7,25,54,0.05)] hover:border-[#2AA7A1]/20 transition-all duration-300"
                >
                  <div className="flex-shrink-0 w-12 h-12 bg-[#DDF4F1] rounded-full flex items-center justify-center">
                    <IconComponent className="text-[#2AA7A1]" size={22} strokeWidth={1.5} />
                  </div>
                  <div>
                    <h3 className="text-[#071936] font-medium text-base sm:text-lg mb-2">
                      {point.title}
                    </h3>
                    <p className="text-[#6B7280] text-sm sm:text-base leading-relaxed">
                      {point.description}
                    </p>
                  </div>
                </div>
              );
            })}
          </div>

          {/* Payment Providers - Real Brand Logos */}
          <div className="mt-10 sm:mt-12 pt-8 sm:pt-10 border-t border-[rgba(7,25,54,0.10)]">
            <p className="text-center text-xs sm:text-sm text-[#6B7280] mb-6">
              Secured by Stripe
            </p>
            <div className="flex items-center justify-center">
              {/* Official Stripe Wordmark */}
              <svg className="h-8 w-auto opacity-70 hover:opacity-100 transition-opacity" viewBox="0 0 60 25" xmlns="http://www.w3.org/2000/svg">
                <path fill="#635BFF" d="M59.64 14.28h-8.06c.19 1.93 1.6 2.55 3.2 2.55 1.64 0 2.96-.37 4.05-.95v3.32a8.33 8.33 0 0 1-4.56 1.1c-4.01 0-6.83-2.5-6.83-7.48 0-4.19 2.39-7.52 6.3-7.52 3.92 0 5.96 3.28 5.96 7.5 0 .4-.04 1.26-.06 1.48zm-5.92-5.62c-1.03 0-2.17.73-2.17 2.58h4.25c0-1.85-1.07-2.58-2.08-2.58zM40.95 20.3c-1.44 0-2.32-.6-2.9-1.04l-.02 4.63-4.12.87V5.57h3.76l.08 1.02a4.7 4.7 0 0 1 3.23-1.29c2.9 0 5.62 2.6 5.62 7.4 0 5.23-2.7 7.6-5.65 7.6zM40 8.95c-.95 0-1.54.34-1.97.81l.02 6.12c.4.44.98.78 1.95.78 1.52 0 2.54-1.65 2.54-3.87 0-2.15-1.04-3.84-2.54-3.84zM28.24 5.57h4.13v14.44h-4.13V5.57zm0-4.7L32.37 0v3.36l-4.13.88V.88zm-4.32 9.35v9.79H19.8V5.57h3.7l.12 1.22c1-1.77 3.07-1.41 3.62-1.22v3.79c-.52-.17-2.29-.43-3.32.86zm-8.55 4.72c0 2.43 2.6 1.68 3.12 1.46v3.36c-.55.3-1.54.54-2.89.54a4.15 4.15 0 0 1-4.27-4.24l.01-13.17 4.02-.86v3.54h3.14V9.1h-3.13v5.85zm-4.91.7c0 2.97-2.31 4.66-5.73 4.66a11.2 11.2 0 0 1-4.46-.93v-3.93c1.38.75 3.1 1.31 4.46 1.31.92 0 1.53-.24 1.53-1C6.26 13.77 0 14.51 0 9.95 0 7.04 2.28 5.3 5.62 5.3c1.36 0 2.72.2 4.09.75v3.88a9.23 9.23 0 0 0-4.1-1.06c-.86 0-1.44.25-1.44.9 0 1.85 6.29.97 6.29 5.88z"/>
              </svg>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
